import { render, staticRenderFns } from "./DisplayLiterature.vue?vue&type=template&id=97c0cb7c&scoped=true&"
import script from "./DisplayLiterature.vue?vue&type=script&lang=js&"
export * from "./DisplayLiterature.vue?vue&type=script&lang=js&"
import style0 from "./DisplayLiterature.vue?vue&type=style&index=0&id=97c0cb7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c0cb7c",
  null
  
)

export default component.exports